import { useState } from "react";

/**
 * Cake Central logo. Renders the real cursive logo hosted on our own server
 * (frontend/public/logo-dark.png + logo-white.png). Falls back to a text
 * wordmark if the image ever fails to load.
 *
 * variant: "dark"  → black cursive logo (for light backgrounds)
 *          "light" → pink/white cursive logo (for dark backgrounds)
 * className: sizing/positioning classes — use height utilities (e.g. "h-10 md:h-14")
 */
export default function Logo({ variant = "dark", className = "" }) {
    const [failed, setFailed] = useState(false);
    const src = variant === "light" ? "/logo-white.png" : "/logo-dark.png";

    if (failed) {
        const color = variant === "light" ? "text-white" : "text-ink";
        return (
            <span
                className={`font-display italic leading-[0.82] text-center ${color} ${className}`}
                data-testid="site-logo"
                aria-label="Cake Central"
            >
                <span className="block">Cake</span>
                <span className="block">Central</span>
            </span>
        );
    }

    return (
        <img
            src={src}
            alt="Cake Central"
            onError={() => setFailed(true)}
            className={`w-auto object-contain ${className}`}
            data-testid="site-logo"
        />
    );
}
